module.exports = __webpack_public_path__ + "static/tooltip1_3-8c87722f7abd8a13c76b1b0cfafa140f.png";